module.exports = __webpack_public_path__ + "img/09d@2x.f1fe2b22.svg";